<script lang="ts">
    export let fill:string = "white";

</script>

<div class="svg-box">
    <svg class="svg-content" width="100%" height="100%" {fill} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 21.5L12 2.5L23 21.5H1ZM19.53 19.5L12 6.49L4.47 19.5H19.53ZM11 16.5V18.5H13V16.5H11ZM11 10.5H13V14.5H11V10.5Z" {fill}/>
    </svg>   
</div>